<template>
  <div class="video-generation-container">
    <!-- 顶部 header -->
    <header>
      <div class="header-content">
        <div class="logo-section">
          <img v-if="theme"
            src="https://mj-uploads.oss-cn-shenzhen.aliyuncs.com/public/aiDesign/System_Default/logo.png" alt="待加载">
          <img v-else src="https://mj-uploads.oss-cn-shenzhen.aliyuncs.com/public/aiDesign/System_Default/dark_logo.png"
            alt="待加载">
        </div>

        <!-- GPU 实时监控 -->
        <gpu-monitor />

        <div class="header-spacer"></div>
        <div class="header-actions">
          <!-- 返回主页按钮 -->
          <div class="home-btn" @click="gohome">
            <span class="iconfont"></span>
            <span>返回主页</span>
          </div>
          <!-- 生图记录按钮 -->
          <div class="header-btn" @click="handleGoToImageLog">
            <span class="iconfont">&#xe640;</span>
            <span>生图记录</span>
          </div>
          <!-- 支持与反馈按钮 -->
          <div class="header-btn" @click="handleOpenFeedback">
            <span class="iconfont">&#xe681;</span>
            <span>支持与反馈</span>
          </div>
          <!-- 用户头像 -->
          <div class="user-avatar">
            <img :src="avatar" alt="待加载">
          </div>
        </div>
      </div>
    </header>

    <!-- 内容区域 -->
    <div class="video-page-wrapper">
    <!-- 左侧精简导航栏（仅视频生成页面使用） -->
    <div class="slim-sidebar">
      <!-- 中间功能按钮区域 -->
      <div class="sidebar-middle">
        <div class="nav-item" @click="handleScriptClick" title="脚本">
          <svg class="nav-icon" viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg">
            <path d="M661.653927 850.681606l-598.429465 0L63.224462 166.398798l598.429465 0L661.653927 850.681606zM605.57777 794.633079 605.57777 222.461651 119.313921 222.461651l0 572.172451L605.57777 794.634102" fill="currentColor"></path>
            <path d="M240.774227 366.237195c-15.442714 0-28.009937-12.568247-28.009937-28.051893 0-15.456017 12.567223-28.024264 28.009937-28.024264l252.366751 0c15.496949 0 28.052916 12.568247 28.052916 28.024264 0 15.483646-12.555967 28.051893-28.052916 28.051893L240.774227 366.237195" fill="currentColor"></path>
            <path d="M240.774227 528.002462c-15.442714 0-28.009937-12.56927-28.009937-28.052916 0-15.497972 12.567223-28.05087 28.009937-28.05087l252.366751 0c15.496949 0 28.052916 12.552897 28.052916 28.05087 0 15.482623-12.555967 28.052916-28.052916 28.052916L240.774227 528.002462" fill="currentColor"></path>
            <path d="M240.774227 689.73703c-15.442714 0-28.009937-12.539594-28.009937-28.010961 0-15.495926 12.567223-28.063149 28.009937-28.063149l252.366751 0c15.496949 0 28.052916 12.567223 28.052916 28.063149 0 15.471366-12.555967 28.010961-28.052916 28.010961L240.774227 689.73703" fill="currentColor"></path>
            <path d="M848.279395 867.327728 717.454814 705.59009l0-539.231201 242.974847 0 0 539.231201L848.279395 867.327728zM844.829829 773.906012l59.499116-85.865623L904.328945 222.461651 773.504364 222.461651l0 463.249693L844.829829 773.906012" fill="currentColor"></path>
            <path d="M754.831073 348.274078 754.831073 292.171316 923.055448 292.171316 923.055448 348.274078 754.831073 348.274078Z" fill="currentColor"></path>
          </svg>
          <span class="nav-label">脚本</span>
        </div>
        <div class="nav-item" @click="handleReverseClick" title="反推">
          <svg class="nav-icon" viewBox="0 0 1429 1024" xmlns="http://www.w3.org/2000/svg">
            <path d="M893.45 200.72c-47.147 0-85.61 37.22-85.61 83.54 0 19.714 7.17 37.498 18.75 51.697l-93.33 99.808c-12.82-7.72-27.985-12.407-44.252-12.407-22.746 0-43.425 8.823-59.003 23.298l-89.607-72.926c6.618-11.718 10.34-25.09 10.34-39.014 0-46.044-38.462-83.541-85.61-83.541s-85.608 37.221-85.608 83.541c0 17.646 5.652 33.913 15.164 47.147l-81.336 83.817c-13.51-9.098-30.328-14.2-47.836-14.2-47.147 0-85.609 37.222-85.609 83.542 0 46.044 38.186 83.541 85.61 83.541 47.146 0 85.608-37.221 85.608-83.54 0-18.75-6.617-35.982-17.094-49.63l80.922-83.403c14.2 10.202 31.431 16.267 50.318 16.267 22.332 0 42.46-8.547 57.762-22.332l90.158 73.202c-6.066 11.58-9.65 24.124-9.65 37.91 0 46.044 38.462 83.541 85.609 83.541s85.609-37.221 85.609-83.54c0-20.128-7.72-38.463-19.851-52.8l92.777-99.395c12.82 8.134 28.674 13.097 45.63 13.097 47.148 0 85.61-37.222 85.61-83.542 0.138-46.182-38.324-83.679-85.471-83.679z m0 0" fill="currentColor"></path>
            <path d="M1041.508 0.551H117.592c-56.66 0-102.566 55.143-102.566 111.527v595.816c0 56.66 46.045 102.704 102.704 102.704h303.285v146.404H173.148c-18.06 0-32.81 14.612-32.81 32.81 0 18.059 14.75 32.81 32.81 32.81H986.09c18.06 0 32.81-14.613 32.81-32.81 0-18.06-14.613-32.81-32.81-32.81H738.223V810.736h303.285c56.659 0 102.703-46.045 102.703-102.704V112.215C1144.35 55.695 1098.305 0.551 1041.508 0.551zM672.74 956.864H486.634V810.598h186.107v146.266z m405.85-248.832c0 20.265-16.543 37.084-37.083 37.084H117.592c-20.265 0-37.084-16.543-37.084-37.084V112.353c0-20.265 16.543-37.083 37.084-37.083h924.054c20.265 0 37.083 16.543 37.083 37.083v595.68z m0 0" fill="currentColor"></path>
          </svg>
          <span class="nav-label">反推</span>
        </div>
        <div class="nav-item" @click="handleInspirationClick" title="灵感">
          <span class="iconfont">&#xe600;</span>
          <span class="nav-label">灵感</span>
        </div>
      </div>

      <!-- 底部功能按钮区域 -->
      <div class="sidebar-bottom">
        <div class="nav-item" @click="handleShortcutClick" title="快捷键">
          <span class="iconfont">&#xe623;</span>
        </div>
        <div class="nav-item" @click="toggleTheme" title="深色模式">
          <span class="iconfont">{{ theme ? '&#xe61c;' : '&#xe61d;' }}</span>
        </div>
      </div>
    </div>

    <!-- 右侧主内容区域 -->
    <div class="right_menu_assistant">
      <!-- 对话历史区域 -->
      <div class="chat-container" ref="chatContainer">
        <div class="chat-history" v-if="chatHistory.length > 0">
          <div v-for="(message, index) in chatHistory" :key="index"
               :class="['message-item', message.role === 'user' ? 'user-message' : 'ai-message']">
            <!-- 用户消息 -->
            <div v-if="message.role === 'user'" class="message-wrapper">
              <!-- 如果用户上传了首尾帧图片，在左侧显示缩略图 -->
              <div v-if="message.startImage || message.endImage" class="message-thumbnails">
                <img v-if="message.startImage" :src="message.startImage" alt="首帧" class="thumbnail-image">
                <img v-if="message.endImage" :src="message.endImage" alt="尾帧" class="thumbnail-image">
              </div>
              <div class="message-content">
                <div class="message-text">{{ message.content }}</div>
                <!-- 生图参数信息 -->
                <div v-if="message.duration || message.frameMode || message.resolution" class="message-params">
                  <span v-if="message.duration">{{ message.duration }}</span>
                  <span v-if="message.frameMode" class="param-divider">|</span>
                  <span v-if="message.frameMode">{{ message.frameMode }}</span>
                  <span v-if="message.resolution" class="param-divider">|</span>
                  <span v-if="message.resolution">{{ message.resolution }}</span>
                </div>
                <!-- 如果用户上传了图片 -->
                <div v-if="message.image" class="message-image">
                  <img :src="message.image" alt="上传的图片">
                </div>
              </div>
              <div class="message-avatar">
                <img :src="avatar" alt="用户">
              </div>
            </div>

            <!-- AI 消息 -->
            <div v-if="message.role === 'assistant'" class="message-wrapper">
              <div class="message-avatar ai-avatar">
                <span class="iconfont">&#xe6a5;</span>
              </div>
              <div class="message-content">
                <div class="message-text" v-if="message.content">{{ message.content }}</div>
                <!-- 如果 AI 返回了视频 -->
                <div v-if="message.video" class="message-video">
                  <video :src="message.video" controls></video>
                  <div class="video-actions">
                    <button class="action-btn download-btn" @click="handleDownloadVideo(message.video)">
                      <span class="iconfont">&#xe693;</span>
                      下载视频
                    </button>
                    <button class="action-btn refill-btn" @click="handleRefill(index)">
                      <span class="iconfont">&#xe685;</span>
                      重新填入
                    </button>
                  </div>
                </div>
                <!-- 失败气泡的按钮组（仅显示重新生成） -->
                <div v-if="message.isError" class="message-actions">
                  <button class="action-btn regenerate-btn" @click="handleRegenerate(index)">
                    重新生成
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 空状态提示 -->
        <div v-else class="empty-state">
          <div class="empty-icon">🎬</div>
          <h3>开始你的视频创作之旅</h3>
          <p>上传一张图片，让AI为你生成精彩的视频内容</p>
        </div>

        <!-- AI 正在输入提示 -->
        <div v-if="aiTyping" class="typing-indicator">
          <div class="typing-avatar">
            <span class="iconfont">&#xe6a5;</span>
          </div>
          <div class="typing-content">
            <div class="typing-dots" v-if="!currentNodeName">
              <span></span>
              <span></span>
              <span></span>
            </div>
            <div v-if="currentNodeName" class="node-executing">
              <span class="node-name">{{ currentNodeName }}</span>
            </div>
            <div v-if="currentProgress" class="progress-text">大约完成：{{ currentProgress }}%</div>
          </div>
        </div>
      </div>
    </div>
    </div>

    <!-- 底部输入导航栏 -->
    <NaviGation_Video
      @chatUpdate="handleChatUpdate"
      @aiTyping="handleAiTyping"
      @progressUpdate="handleProgressUpdate"
      @nodeUpdate="handleNodeUpdate"
      @scrollToBottom="scrollToBottom"
      :initialChatHistory="chatHistory"
    />

    <!-- 支持与反馈弹窗 -->
    <discussion-board
      class="discussion-board"
      :boardvisible="boardvisible"
      :disscussType="disscussType"
      @update:boardvisible="boardvisible = $event"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import localStorageUtils from '@/utils/setLocalStorage'
import { Message } from 'element-ui'
import NaviGation_Video from '@/components/NaviGation_Video.vue'

export default {
  name: 'VideoGeneration',
  components: {
    NaviGation_Video
  },
  computed: {
    ...mapGetters(['avatar'])
  },
  data() {
    return {
      theme: true, // 主题模式
      chatHistory: [], // 对话历史
      aiTyping: false, // AI 是否正在输入
      currentProgress: '', // 当前进度
      boardvisible: false, // 支持与反馈弹窗显示状态
      disscussType: 'video_generation', // 讨论区类型
      currentNodeName: '' // 当前执行的节点名称
    }
  },
  created() {
    // 加载主题设置
    const savedTheme = localStorageUtils.getItem('theme')
    if (savedTheme !== null) {
      this.theme = savedTheme
    }
    // 加载对话历史
    this.loadChatHistory()
  },
  mounted() {
    // 滚动到底部
    this.$nextTick(() => {
      if (this.chatHistory.length > 0) {
        this.scrollToBottom()
      }
    })
  },
  methods: {
    // 返回主页
    gohome() {
      this.$router.push({ path: '/' })
    },
    // 脚本功能 - 跳转到视频脚本生成页面
    handleScriptClick() {
      this.$router.push({ path: '/index/morejoyassistant_script' })
    },
    // 反推功能（占位）
    handleReverseClick() {
      Message.warning('o(*￣▽￣*)ブ开发者正在开发中,敬请期待😋!')
    },
    // 灵感功能（占位）
    handleInspirationClick() {
      Message.warning('o(*￣▽￣*)ブ开发者正在开发中,敬请期待😋!')
    },
    // 快捷键功能（占位）
    handleShortcutClick() {
      Message.info('快捷键说明：\nCtrl + Enter: 发送消息\nCtrl + V: 粘贴图片')
    },
    // 切换主题
    toggleTheme() {
      this.theme = !this.theme
      localStorageUtils.setItem('theme', this.theme)
      Message.success(this.theme ? '已切换到浅色模式' : '已切换到深色模式')
    },
    // 跳转到生图记录
    handleGoToImageLog() {
      const targetPath = '/userimagelog'
      if (this.$router.history.current.fullPath !== targetPath) {
        this.$router.push({ path: targetPath })
      }
    },
    // 打开支持与反馈
    handleOpenFeedback() {
      this.boardvisible = true
    },
    // 处理对话更新
    handleChatUpdate(history) {
      this.chatHistory = history
      this.saveChatHistory()
      this.$nextTick(() => {
        this.scrollToBottom()
      })
    },
    // 处理 AI 输入状态
    handleAiTyping(isTyping) {
      this.aiTyping = isTyping
      if (isTyping) {
        this.currentProgress = '' // 重置进度
        this.$nextTick(() => {
          this.scrollToBottom()
        })
      }
    },
    // 处理进度更新
    handleProgressUpdate(progress) {
      this.currentProgress = progress
      this.$nextTick(() => {
        this.scrollToBottom()
      })
    },
    // 处理节点更新
    handleNodeUpdate(nodeName) {
      this.currentNodeName = nodeName
      this.$nextTick(() => {
        this.scrollToBottom()
      })
    },
    // 滚动到底部
    scrollToBottom() {
      const container = this.$refs.chatContainer
      if (container) {
        container.scrollTop = container.scrollHeight
      }
    },
    // 加载对话历史
    loadChatHistory() {
      const userInfo = this.$store.state.morejoy_assistant?.userInfo
      if (!userInfo || !userInfo.userId) {
        // 用户未登录，跳过加载
        return
      }
      const storageKey = `video_chat_history_${userInfo.userId}`
      const savedHistory = localStorage.getItem(storageKey)
      if (savedHistory) {
        try {
          this.chatHistory = JSON.parse(savedHistory)
          console.log(`加载用户 ${userInfo.userId} 的视频生成对话历史:`, this.chatHistory.length, '条')
        } catch (e) {
          console.error('解析对话历史失败:', e)
          this.chatHistory = []
        }
      }
    },
    // 保存对话历史
    saveChatHistory() {
      const userInfo = this.$store.state.morejoy_assistant?.userInfo
      if (!userInfo || !userInfo.userId) {
        // 用户未登录，跳过保存
        return
      }
      // 限制最多保存10轮对话（20条消息）
      let historyToSave = [...this.chatHistory]
      if (historyToSave.length > 20) {
        historyToSave = historyToSave.slice(-20)
        this.chatHistory = historyToSave
      }
      const storageKey = `video_chat_history_${userInfo.userId}`
      localStorage.setItem(storageKey, JSON.stringify(historyToSave))
    },
    // 下载视频
    async handleDownloadVideo(videoUrl) {
      try {
        Message.info('正在下载视频...')
        const response = await fetch(videoUrl)
        const blob = await response.blob()
        const link = document.createElement('a')
        const url = window.URL.createObjectURL(blob)
        link.href = url
        const timestamp = new Date().getTime()
        link.download = `video_${timestamp}.mp4`
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        window.URL.revokeObjectURL(url)
        Message.success('视频下载成功!')
      } catch (error) {
        console.error('下载视频失败:', error)
        Message.error('下载视频失败，请稍后再试!')
      }
    },
    // 重新生成
    handleRegenerate(index) {
      // 找到对应的用户消息（AI消息的前一条）
      if (index > 0) {
        const userMessage = this.chatHistory[index - 1]
        if (userMessage && userMessage.role === 'user') {
          // 移除失败的 AI 回复
          this.chatHistory.splice(index, 1)
          this.saveChatHistory()
          // 通过 sessionStorage 传递重新生成的参数给子组件
          const regenerateData = {
            content: userMessage.content,
            startImage: userMessage.startImage,
            endImage: userMessage.endImage,
            duration: userMessage.duration,
            frameMode: userMessage.frameMode,
            resolution: userMessage.resolution
          }
          sessionStorage.setItem('video_regenerate', JSON.stringify(regenerateData))
          // 通知子组件重新生成
          this.$nextTick(() => {
            // 触发子组件的重新生成（通过事件总线或直接调用）
            this.$root.$emit('video-regenerate', regenerateData)
          })
        }
      }
    },
    // 重新填入（仅回填数据，不自动生成）
    handleRefill(index) {
      if (index > 0) {
        const userMessage = this.chatHistory[index - 1]
        if (userMessage && userMessage.role === 'user') {
          const refillData = {
            content: userMessage.content,
            startImage: userMessage.startImage,
            endImage: userMessage.endImage,
            duration: userMessage.duration,
            frameMode: userMessage.frameMode,
            resolution: userMessage.resolution
          }
          this.$root.$emit('video-refill', refillData)
        }
      }
    }
  }
}
</script>

<style lang="less" scoped>
@import "@/style/common.less";
@import "@/assets/fonts/style.css";
@import "@/assets/font_sczlgzino/iconfont.css";

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html {
  font-family: "icomoon";
  overflow: hidden;
}

.iconfont {
  font-family: "iconfont" !important;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-size: 25px;
}

// 页面最外层容器
.video-generation-container {
  display: flex;
  flex-direction: column;
  width: 100vw;
  height: 100vh;
  background: white;
  overflow: hidden;
}

// 顶部 header
header {
  height: 95px;
  width: 100%;
  padding: 10px 30px;
  font-family: "icomoon";
  font-size: 18px;
  border-bottom: 1px solid #e5e7eb;
  background: white;

  .header-content {
    display: flex;
    align-items: center;
    height: 100%;
  }

  .logo-section {
    width: 230px;
    height: 75px;
    display: flex;
    align-items: center;
    padding: 10px;

    img {
      width: 230px;
      object-fit: cover;
      cursor: pointer;
      transition: all 0.3s;

      &:hover {
        transform: scale(1.05);
      }
    }
  }

  .header-spacer {
    flex: 1;
  }

  .header-actions {
    display: flex;
    gap: 20px;
    align-items: center;

    .home-btn {
      display: flex;
      align-items: center;
      gap: 8px;
      padding: 12px 24px;
      border-radius: 10px;
      background-color: #ff8c42;
      color: white;
      cursor: pointer;
      transition: all 0.3s;
      font-size: 16px;
      font-weight: 500;
      white-space: nowrap;

      .iconfont {
        font-size: 20px;
      }

      &:hover {
        background-color: #ff7a2e;
        transform: translateY(-2px);
        box-shadow: 0 4px 12px rgba(255, 140, 66, 0.3);
      }
    }

    .header-btn {
      display: flex;
      align-items: center;
      gap: 8px;
      padding: 12px 24px;
      border-radius: 10px;
      background-color: rgba(39, 41, 46, 0.05);
      cursor: pointer;
      transition: all 0.3s;
      font-size: 16px;
      color: #333;
      white-space: nowrap;

      .iconfont {
        font-size: 20px;
      }

      &:hover {
        background-color: #f0f0f0;
        transform: translateY(-2px);
        box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
      }
    }

    .user-avatar {
      display: flex;
      width: 50px;
      height: 50px;
      border: 2px solid #e5e7eb;
      border-radius: 50%;
      overflow: hidden;
      justify-content: center;
      align-items: center;

      img {
        cursor: pointer;
        width: 100%;
        height: 100%;
        object-fit: cover;
        transition: all 0.3s;

        &:hover {
          transform: scale(1.1);
        }
      }
    }
  }
}

// 内容区域包裹器
.video-page-wrapper {
  display: flex;
  width: 100vw;
  height: calc(100vh - 95px);
  overflow: hidden;
}

// 左侧精简导航栏（仅视频生成页面使用）
.slim-sidebar {
  width: 80px;
  height: calc(100vh - 95px);
  background: white;
  border-right: 1px solid #e5e7eb;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px 0;
  box-shadow: 2px 0 8px rgba(0, 0, 0, 0.05);
  flex-shrink: 0;

  .sidebar-middle {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 30px;
    align-items: center;
    justify-content: center;
  }

  .sidebar-bottom {
    display: flex;
    flex-direction: column;
    gap: 20px;
    align-items: center;
  }

  .nav-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 6px;
    padding: 12px 0;
    cursor: pointer;
    transition: all 0.3s;
    border-radius: 8px;
    width: 60px;

    .iconfont {
      font-size: 24px;
      color: #666;
      transition: all 0.3s;
    }

    .nav-icon {
      width: 24px;
      height: 24px;
      color: #666;
      transition: all 0.3s;
    }

    .nav-label {
      font-size: 12px;
      color: #999;
      transition: all 0.3s;
    }

    &:hover {
      background: #f5f7fa;

      .iconfont {
        color: @morejoy;
      }

      .nav-icon {
        color: @morejoy;
      }

      .nav-label {
        color: @morejoy;
      }
    }
  }
}

.right_menu_assistant {
  flex: 1;
  height: calc(100vh - 95px);
  display: flex;
  flex-direction: column;
  background: white;
  overflow: hidden;
  position: relative;
}

// 对话容器
.chat-container {
  flex: 1;
  overflow-y: auto;
  padding: 30px 40px;
  padding-bottom: 250px; // 为底部输入框预留空间
  scrollbar-width: thin;
  scrollbar-color: @basicselect transparent;

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background: @basicselect;
    border-radius: 3px;

    &:hover {
      background: @morejoy;
    }
  }
}

// 对话历史
.chat-history {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 30px;
}

// 消息项
.message-item {
  display: flex;
  animation: fadeIn 0.3s ease;

  &.user-message {
    justify-content: flex-end;
  }

  &.ai-message {
    justify-content: flex-start;
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.message-wrapper {
  display: flex;
  gap: 15px;
  max-width: 75%;
}

.message-avatar {
  width: 45px;
  height: 45px;
  border-radius: 50%;
  overflow: hidden;
  flex-shrink: 0;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  &.ai-avatar {
    background: linear-gradient(135deg, @morejoy 0%, #ff7a2e 100%);
    display: flex;
    align-items: center;
    justify-content: center;

    .iconfont {
      font-size: 24px;
      color: white;
    }
  }
}

.message-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

// 首尾帧缩略图容器
.message-thumbnails {
  display: flex;
  flex-direction: row;
  gap: 10px;
  margin-right: 12px;
  flex-shrink: 0;
  align-items: flex-start;

  .thumbnail-image {
    width: 60px;
    height: 60px;
    border-radius: 8px;
    object-fit: cover;
    border: 2px solid rgba(255, 255, 255, 0.8);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
    transition: all 0.3s;

    &:hover {
      transform: scale(1.1);
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.25);
    }
  }
}

.user-message .message-text {
  background: @morejoy;
  color: white;
  padding: 15px 20px;
  border-radius: 18px 18px 4px 18px;
  font-size: 16px;
  line-height: 1.6;
  word-wrap: break-word;
}

// 生图参数信息
.message-params {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  color: #999;
  margin-top: 8px;
  padding: 0 8px;

  span {
    color: #999;
  }

  .param-divider {
    color: #ccc;
    font-weight: 300;
  }
}

.ai-message .message-text {
  background: white;
  color: #333;
  padding: 15px 20px;
  border-radius: 18px 18px 18px 4px;
  font-size: 16px;
  line-height: 1.6;
  word-wrap: break-word;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

.message-image {
  max-width: 400px;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);

  img {
    width: 100%;
    height: auto;
    display: block;
  }
}

.message-video {
  max-width: 600px;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);

  video {
    width: 100%;
    height: auto;
    display: block;
    background: #000;
  }

  .video-actions {
    padding: 12px;
    background: white;
    display: flex;
    gap: 10px;
    justify-content: flex-end;

    .action-btn {
      display: flex;
      align-items: center;
      gap: 6px;
      padding: 8px 16px;
      border: none;
      border-radius: 8px;
      background: @morejoy;
      color: white;
      cursor: pointer;
      transition: all 0.3s;
      font-size: 14px;

      .iconfont {
        font-size: 16px;
      }

      &:hover {
        background: #ff7a2e;
        transform: translateY(-2px);
        box-shadow: 0 4px 8px rgba(255, 140, 66, 0.3);
      }

      // 重新填入按钮（描边风格，与下载按钮区分）
      &.refill-btn {
        background: white;
        color: @morejoy;
        border: 1px solid @morejoy;

        &:hover {
          background: #fff8f3;
          border-color: #ff7a2e;
          color: #ff7a2e;
          box-shadow: 0 4px 8px rgba(255, 140, 66, 0.15);
        }
      }
    }
  }
}

// 消息按钮组（重新生成按钮）
.message-actions {
  display: flex;
  gap: 10px;
  margin-top: 12px;
  width: 100%;
  flex-basis: 100%; // 强制换行

  .action-btn {
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 8px 16px;
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    background: white;
    color: #666;
    cursor: pointer;
    transition: all 0.3s;
    font-size: 14px;

    &:hover {
      background: #fff8f3;
      color: @morejoy;
      border-color: @morejoy;
    }

    &.regenerate-btn {
      &:hover {
        background: @morejoy;
        color: white;
        border-color: @morejoy;
      }
    }
  }
}

// 空状态
.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  color: #999;

  .empty-icon {
    font-size: 80px;
    margin-bottom: 20px;
    opacity: 0.5;
  }

  h3 {
    font-size: 24px;
    font-weight: 600;
    color: #666;
    margin: 0 0 10px 0;
  }

  p {
    font-size: 16px;
    color: #999;
    margin: 0;
  }
}

// AI 输入提示
.typing-indicator {
  display: flex;
  gap: 15px;
  align-items: center;
  max-width: 1200px;
  margin: 0 auto;
  animation: fadeIn 0.3s ease;

  .typing-avatar {
    width: 45px;
    height: 45px;
    border-radius: 50%;
    background: linear-gradient(135deg, @morejoy 0%, #ff7a2e 100%);
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;

    .iconfont {
      font-size: 24px;
      color: white;
    }
  }

  .typing-content {
    display: flex;
    flex-direction: column;
    gap: 6px;

    .typing-dots {
      display: flex;
      gap: 6px;
      padding: 15px 20px;
      background: white;
      border-radius: 18px 18px 18px 4px;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);

      span {
        width: 8px;
        height: 8px;
        border-radius: 50%;
        background: @morejoy;
        animation: typing 1.4s infinite;

        &:nth-child(2) {
          animation-delay: 0.2s;
        }

        &:nth-child(3) {
          animation-delay: 0.4s;
        }
      }
    }

    .node-executing {
      padding: 15px 25px;
      background: white;
      border-radius: 18px 18px 18px 4px;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);

      .node-name {
        font-size: 13px;
        color: #999;
        font-weight: 400;
        animation: breathe 2s ease-in-out infinite;
        display: inline-block;
      }
    }

    .progress-text {
      font-size: 14px;
      color: #999;
      text-align: center;
    }
  }
}

@keyframes typing {
  0%, 60%, 100% {
    opacity: 0.3;
    transform: translateY(0);
  }
  30% {
    opacity: 1;
    transform: translateY(-10px);
  }
}

@keyframes breathe {
  0%, 100% {
    opacity: 0.6;
    transform: scale(1);
  }
  50% {
    opacity: 1;
    transform: scale(1.05);
  }
}
</style>
